import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import RelatedRolesComponent from 'bundles/browse-common/components/RelatedRolesComponent';
import { useRelatedRoles } from 'bundles/browse-common/contexts/RelatedRolesContext';
import type { PageConfig_ComponentConfig_PageConfig_RelatedRolesComponent_Fragment as RelatedRolesComponentPageConfig } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

import _t from 'i18n!nls/browse-common';

type Props = {
  pageConfigComponent: RelatedRolesComponentPageConfig;
};

const RelatedRolesRenderer = (props: Props) => {
  const context = useRelatedRoles();
  if (!context) {
    logger.warn('RelatedRolesRenderer expected RelatedRolesContext');
    return null;
  }

  const { loading, collection } = context;

  return (
    <RelatedRolesComponent
      hideFilters={true}
      isCollectionLoading={loading}
      collection={collection}
      headline={_t('Related roles')}
      description={_t('Gain the knowledge and skills you need to advance.')}
    />
  );
};

export default RelatedRolesRenderer;
